import api from "./api";

class AclAPI {


  async getPerfis(headers) {

    const response = await api.get("/getPerfis", { headers });
    return response;
  }

  async getModulos(headers) {

    const response = await api.get("/getModulos", { headers });
    return response;
  }

  async addModulo(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addModulo',
      headers,
      data: params
    });
    return response;
  }


  async delModulo(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delModulo',
      headers,
      data: params
    });
    return response;
  }


  async addPerfil(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addPerfil',
      headers,
      data: params
    });
    return response;
  }


  async delPerfil(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delPerfil',
      headers,
      data: params
    });
    return response;
  }


  async getAplicativos(headers) {

    const response = await api.get("/getAplicativos", { headers });
    return response;
  }

  async addAplicativo(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addAplicativo',
      headers,
      data: params
    });
    return response;
  }


  async delAplicativo(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delAplicativo',
      headers,
      data: params
    });
    return response;
  }


  async getPermissoes(headers) {

    const response = await api.get("/getPermissoes", { headers });
    return response;
  }

  async addPermissao(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addPermissao',
      headers,
      data: params
    });
    return response;
  }


  async delPermissao(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delPermissao',
      headers,
      data: params
    });
    return response;
  }



  async getCandidatos(headers) {

    const response = await api.get("/getCandidatos", { headers });
    return response;
  }

  async getAssessoresLista(headers) {

    const response = await api.get("/getAssessoresLista", { headers });
    return response;
  }

  async getMeusCandidatos(headers) {

    const response = await api.get("/getMeusCandidatos", { headers });
    return response;
  }

  async addCandidato(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addCandidato',
      headers,
      data: params
    });
    return response;
  }


  async delCandidato(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delCandidato',
      headers,
      data: params
    });
    return response;
  }



  async getMetas(headers, params) {

    const response = await api.get("/getMetas", { headers, params });
    return response;
  }


  async getMetasCruzada(headers, params) {

    const response = await api.get("/getMetasCruzada", { headers, params });
    return response;
  }



  async addMeta(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addMeta',
      headers,
      data: params
    });
    return response;
  }


  async delMeta(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delMeta',
      headers,
      data: params
    });
    return response;
  }




  async getPessoas(headers, params) {

    const response = await api.get("/getPessoas", { headers, params });
    return response;
  }


  async getPessoasGeral(headers, params) {

    const response = await api.get("/getPessoasGeral", { headers, params });
    return response;
  }


  async getApuracaoPorZona(headers, params) {

    const response = await api.get("/apuracao_por_zona", { headers, params });
    return response;
  }





  async addPessoa(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addPessoa',
      headers,
      data: params
    });
    return response;
  }


  async delPessoa(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delPessoa',
      headers,
      data: params
    });
    return response;
  }


  async getZonas(headers) {

    const response = await api.get("/getZonas", { headers });
    return response;
  }

  async addZona(headers, params) {
    const response = await api.post('/addZona', params, { headers });
    return response;
  }

  async delZona(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delZona',
      headers,
      data: params
    });
    return response;
  }


  async getZonasGeograficas(headers) {

    const response = await api.get("/getZonasGeograficas", { headers });
    return response;
  }

  async addZonaGeografica(headers, params) {
    const response = await api.post('/addZonaGeografica', params, { headers });
    return response;
  }

  async delZonaGeografica(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delZonaGeografica',
      headers,
      data: params
    });
    return response;
  }

  async getMunicipios(headers) {

    const response = await api.get("/getMunicipios", { headers });
    return response;
  }

  async getBairros(headers) {

    const response = await api.get("/getBairros", { headers });
    return response;
  }

  async getZonaBairros(headers) {

    const response = await api.get("/getZonaBairros", { headers });
    return response;
  }

  async getPessoasCobertura(headers, params) {

    const response = await api.get("/getPessoasCobertura", { headers, params });
    return response;
  }

  async getDistribuicaoPessoas(headers, params) {

    const response = await api.get("/getDistribuicaoPessoas", { headers, params });
    return response;
  }

  async getDetalheDistribuicao(headers, params) {

    const response = await api.get("/getDetalheDistribuicao", { headers, params });
    return response;
  }

}

export default new AclAPI();
